<style scoped lang="scss">
  .not-found-page {
    @include padding-y(40px);
    @include padding-x(20px);
    display: flex;
    flex-direction: column;
    align-items: center;

    .error-image {
      img {
        max-width: 200px;
        max-height: 200px;
      }
    }

    .error-text {
      margin-top: 30px;
      text-align: center;
      font-weight: 600;
      font-size: 50px;
    }
  }
</style>

<template>
  <div class="not-found-page">
    <div class="error-image">
      <img :src="$asAppAsset('/images/da-wtf.png')"/>
    </div>
    <div class="error-text">
      404
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotFoundPage',
  created() {
    this.$emit('load')
  },
}
</script>
